import LineIcon from "pages/HomePage/components/LineIcon";
import React, { useCallback, useState } from "react";

import type { CollapsibleSectionProps } from "../settings.types";

import styles from "./CollapsibleSection.module.css";

/**
 * Settings card whose body can be collapsed behind its title row. The chevron button toggles the
 * body; an optional header action (e.g. the billing address edit button) stays visible and usable
 * in both states.
 */
const CollapsibleSection = ({ children, defaultExpanded = false, headerAction, title }: CollapsibleSectionProps) => {
	const [isExpanded, setIsExpanded] = useState(defaultExpanded);
	const onToggle = useCallback((): void => setIsExpanded((expanded: boolean) => !expanded), []);

	return (
		<section className={styles.card}>
			<div className={styles.head}>
				<button aria-expanded={isExpanded} className={styles.toggle} onClick={onToggle} type="button">
					<span className={styles.title}>{title}</span>
					<span aria-hidden="true" className={`${styles.chevron} ${isExpanded ? styles.chevronOpen : ""}`}>
						<LineIcon name="chevronDown" />
					</span>
				</button>
				{headerAction}
			</div>
			{isExpanded && <div className={styles.content}>{children}</div>}
		</section>
	);
};

export default CollapsibleSection;
